<template>
    <div v-wechat-title="title" class="padding10" v-if="surgeryId && surgeryId > 0">
        <el-row type="flex" align="middle">
            <!-- <el-col :md="5" :xl="3">
                <item-input type="search" placeholder="关键字搜索" v-model="searchValue" @input="search()"></item-input>
            </el-col> -->
            <el-col :md="14" class="align-left">
                <el-radio-group v-model="sApplyType" size="small" style="text-align: left" v-if="applytype == 2">
                    <el-radio-button v-if="isHavePermissions(`zq`)" label="2">择期</el-radio-button>
                    <el-radio-button v-if="isHavePermissions(`jz`)" label="1">急诊</el-radio-button>
                </el-radio-group>
                <item-input
                    ref="scan-code"
                    type="scan"
                    v-model="scancode"
                    placeholder="扫码登记"
                    :autofocus="true"
                    @input="scanSupplies"
                    style="width: 250px;"
                ></item-input>
            </el-col>
            <el-col :md="10" class="align-right">
                <el-button type="primary" size="mini" @click="SaveUseSupplies">保存</el-button>
                <el-button type="primary" size="mini" @click="loadSupplyApplyView">耗材登记</el-button>
                <el-button type="primary" size="mini" v-if="isHavePermissions(`export`)" @click="exportSupplies">导出</el-button>
                <el-button type="primary" size="mini" v-if="isHavePermissions(`print`)" @click="printSupplies">打印</el-button>
                <el-button size="mini" @click="loadDamagedView">损耗记录</el-button>
            </el-col>
        </el-row>
        <list-view
            style="margin-top: 10px;"
            :showSequence="true"
            :selection="false"
            ref="supplies-list"
            :datalist="allData"
            :tableHeight="this.screenHeight - 186"
            @extrabutton-click="ExtraButtonClick"
            :columns="columnList"
            :buttons="[]"
            :reserveSelection="false"
        >
            <template slot="send_state" slot-scope="{ row }">
                <p :title="titleLabel(row)" :style="getstateStyle(row)">
                    {{ row.send_state }}
                </p>
            </template>
        </list-view>
        <cus-dialog class="table-h360" title="耗材登记" :visible.sync="collectSupplyApply.dialogFormVisible" :close-on-click-modal="false" width="60%" @confirm="addToList">
            <el-row class="padding20">
                <el-col :span="2" class="align-left"><span class="line-height35">耗材申请:</span></el-col>
                <el-col :span="22">
                    <item-input type="select" :collapseTags="false" v-model="collectSupplyApply.selected_SupplyApply" :options="collectSupplyApply.supplyApplyOption" :clearable="true"></item-input>
                </el-col>
            </el-row>
            <list-view @extrabutton-click="ExtraButtonClick" :columns="collectSupplyApply.columnList" :datalist="collectSupplyApply.datalist" :selectAll="true" :selection="true"></list-view>
        </cus-dialog>
        <!-- 破损记录 -->
        <el-dialog destroy-on-close class="form-table-h380" title="破损记录" :visible.sync="damagedView.dialogFormVisible" :close-on-click-modal="false" width="95%">
            <cus-form ref="form-damaged" :data="damagedView" :columns="damagedViewColumns" @extrabutton-click="ExtraButtonClick"></cus-form>
        </el-dialog>
    </div>
    <p v-else class="no-surgery">暂无手术</p>
</template>
<script>
import { mapGetters } from 'vuex'
import SaveAs from '@/components/Dictionary/Supplies/SaveAs.vue'
export default {
    name: `SupplyRegistration`,
    components: { SaveAs },
    props: {},
    data() {
        return {
            title: `耗材登记`,
            SupplyApplyView: {
                dialogFormVisible: false,
                data: {}
            },
            supplyApplyScheduleTime: this.$root.SupplyApplyScheduleTime || `08:00`,
            scancode: ``,
            checkedRow: [],
            allData: [],
            supplyApplyOption: [],
            supplyApplyDetailOption: [],
            applytype: this.$route.query.applytype || 1,
            surgeryId: this.$route.query.surgery_id,
            inRoom: null,
            roomid: null,
            damagedView: {
                dialogFormVisible: false,
                damaged: []
            },
            sApplyType: 2,
            url: {
                baseURL: `/api/AcisSystem/Supplies`,
                get: query => {
                    // let that = this
                    // return new Promise((resolve, reject) => {
                    //     let __index = _.now()
                    // })
                }
            },
            collectSupplyApply: {
                selected_SupplyApply: null,
                supplyApplyOption: [],
                dialogFormVisible: false,
                datalist: [],
                columnList: [
                    {
                        type: `string`,
                        prop: `biz_supplie_apply_detail_id`,
                        label: `申请明细ID`,
                        isKey: true
                    },
                    {
                        type: `string`,
                        prop: `dic_supplies_id`,
                        label: `物资ID`, // 固定耗材 biz_supplie_apply_detail_id 都=0 ,此时 biz_supplie_apply_detail_id会重复
                        isKey: true
                    },
                    {
                        type: `remoteselect`,
                        prop: `dic_supplies`,
                        label: `名称`,
                        isListable: true,
                        readonly: function(that, { row, area }) {
                            return true
                        },
                        options: `/api/AcisSystem/Supplies/Search`
                    },
                    {
                        type: `string`,
                        prop: `spec`,
                        label: `规格`,
                        width: `200`,
                        isListable: true
                    },
                    {
                        type: `string`,
                        prop: `category`,
                        label: `耗材分类`,
                        width: `150`,
                        isListable: true
                    },
                    {
                        type: `bool`,
                        prop: `is_fixed`,
                        label: `固定耗材`,
                        width: `100`,
                        options: `enum_bool`,
                        isListable: true
                    },
                    {
                        type: `number`,
                        prop: `quantity`,
                        label: `申请数量`,
                        width: `100`,
                        isListable: true
                    },
                    {
                        type: `number`,
                        prop: `applyquantity`,
                        label: `转移数量`,
                        width: `100`,
                        isListable: true
                    }
                ]
            }
        }
    },
    created() {
        this.loadSurgery()
    },
    mounted() {
        this.loadData()
    },
    computed: {
        ...mapGetters([`ward_auth`, `currentUser`, `screenHeight`, `active_ward`, `sys_enums`, `permissions`]),
        tableHeight() {
            return (this.screenHeight && this.screenHeight - 190) || 0
        },
        columnList() {
            // let me = this
            let cols = [
                {
                    type: `string`,
                    prop: `___index`,
                    label: `unique`,
                    isKey: true
                },
                {
                    type: `string`,
                    prop: `id`,
                    label: `编号`,
                    isKey: true
                },
                {
                    type: `remoteselect`,
                    prop: `dic_supplies`,
                    label: `名称`,
                    isListable: true,
                    readonly: function(that, { row, area }) {
                        if (area == `list`) {
                            if (row.id && row.id > 0) {
                                return true
                            } else {
                                return false
                            }
                        }
                        return true
                    },
                    options: `/api/AcisSystem/Supplies/Search`
                },
                {
                    type: `string`,
                    prop: `spec`,
                    label: `规格`,
                    width: `180`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `category`,
                    label: `耗材分类`,
                    width: `120`,
                    isListable: true
                },
                {
                    type: `number`,
                    prop: `use_quantity`,
                    label: `使用数量`,
                    width: `80`,
                    isListable: true,
                    readonly: function(that, { row, area }) {
                        return false
                    },
                    default: 0
                },
                {
                    type: `string`,
                    prop: `modifier`,
                    label: `修改人`,
                    width: `180`,
                    isListable: true
                },
                {
                    type: `datetime`,
                    prop: `modify_date`,
                    label: `修改时间`,
                    width: `180`,
                    isListable: true
                },
                {
                    type: `buttongroup`,
                    prop: `oper`,
                    label: `操作`,
                    width: `60`,
                    isListable: true,
                    fixed: `right`,
                    readonly: false,
                    options: [
                        {
                            class: `is-plain`,
                            label: `删除`,
                            icon: ``,
                            type: `danger`,
                            emit: `removeItem`,
                            permission: `default`
                        }
                    ]
                }
            ]
            return cols
        },
        damagedViewColumns() {
            let that = this
            return [
                {
                    type: `select`,
                    prop: `applyid`,
                    label: `申请单`,
                    options: this.supplyApplyOption,
                    colspan: 4,
                    change: function($that, { row }) {
                        if (row && row.applyid > 0) {
                            that.loadApplyDetail(row.applyid)
                        }
                    },
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `select`,
                    prop: `biz_supplie_apply_detail_id`,
                    label: `耗材`,
                    options: this.supplyApplyDetailOption,
                    colspan: 4,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `number`,
                    prop: `amount`,
                    label: `数量`,
                    colspan: 4,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }],
                    default: 1
                },
                {
                    type: `select`,
                    prop: `enum_stuff_destination`,
                    label: `去向`,
                    options: this.sys_enums.Enum_StuffDestination,
                    colspan: 4,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }],
                    default: 1
                },
                {
                    type: `string`,
                    prop: `remark`,
                    label: `备注`,
                    colspan: 4
                },
                {
                    type: `buttongroup`,
                    prop: `oper`,
                    label: ``,
                    options: [
                        {
                            // class:"is-plain",
                            label: `添加`,
                            type: `primary`,
                            emit: `appendDamaged`,
                            permission: `default`
                        }
                    ],
                    colspan: 4
                },
                {
                    type: `table2`,
                    prop: `damaged`,
                    label: { content: `耗损记录`, position: `top` },
                    options: [
                        {
                            type: `string`,
                            prop: `id`,
                            label: `编号`
                        },
                        {
                            type: `string`,
                            prop: `supplies_name`,
                            label: `名称`,
                            isListable: true
                        },
                        {
                            type: `string`,
                            prop: `amount`,
                            label: `数量`,
                            isListable: true
                        },
                        {
                            type: `select`,
                            prop: `stuff_destination`,
                            label: `去向`,
                            isListable: true,
                            options: this.sys_enums.Enum_StuffDestination
                        },
                        {
                            type: `string`,
                            prop: `remark`,
                            label: `备注`,
                            isListable: true
                        },
                        {
                            type: `buttongroup`,
                            prop: `oper`,
                            label: `操作`,
                            width: `100`,
                            readonly: false,
                            isListable: true,
                            options: [
                                {
                                    class: `is-plain`,
                                    label: `删除`,
                                    type: `danger`,
                                    emit: `deleteDamaged`,
                                    permission: `default`,
                                    isListable: true
                                }
                            ]
                        }
                    ],
                    colspan: 24
                }
            ]
        }
    },
    inject: [`reload`],
    methods: {
        isHavePermissions(permiskey) {
            return this.permissions && ((this.applytype == 1 && this.permissions.findIndex(item => item.permission === `mzSupplyApply:${permiskey}`) != -1) ||
                (this.applytype == 2 && this.permissions.findIndex(item => item.permission === `hlSupplyApply:${permiskey}`) != -1 &&
                (this.permissions.findIndex(item => item.permission === `hlSupplyApply:zq`) != -1 ||
                  this.permissions.findIndex(item => item.permission === `hlSupplyApply:jz`) != -1)
                ))
        },
        exportSupplies() {
            let that = this
            if (!that.surgeryId) {
                return
            }
            let req = that.myaxios.post(`/api/Nursing/UseSupplies/GetSupplieForExport?surgeryId=${that.surgeryId}&applytype=${that.applytype}`)
            req.then(data => {
                if (data.length <= 0) {
                    this.$message.warning(`暂无导出数据`)
                    return
                }
                that.myaxios.export_excel(data, `耗材登记.xls`)
            }).catch(e => {
                that.$message.error(`导出数据出错`)
            })
        },
        printSupplies() {
            let that = this
            if (!that.surgeryId) {
                return
            }
            let inRoomTime = (this.inRoom && this.$moment(this.inRoom)) || this.$moment()
            let req2 = this.myaxios.get(`/api/AcisSystem/Config/GetByKey?key=isShowSendPrintMessage`)
            req2.then(isShow => {
                let doccode = this.applytype == 1 ? `SR001` : `SR002`
                this.$store.dispatch(`PRINT_PDF`, {
                    host: this.$root.DOCSERVICE_BASE,
                    params: Object.assign(
                        {
                            docid: this.$root.DOCUMENT[`${doccode}`],
                            id1: that.surgeryId,
                            objId: `${that.applytype}`,
                            from: inRoomTime.format(`YYYYMMDDHHmm`),
                            to: inRoomTime
                                .add(1, `days`)
                                .format(`YYYYMMDDHHmm`)
                        },
                        { isShowSendPrintMessage: isShow.value }
                    )
                })
            }).catch(e => {
                console.log(e)
            })
        },
        loadData() {
            let that = this
            if (!this.surgeryId) return
            let req = this.myaxios.get(`/api/Nursing/UseSupplies/CollectedSupplies?surgeryInfoId=${this.surgeryId}&applytype=${this.applytype}`)
            req.then(data => {
                let r = data.map((d, index) => {
                    d.id = d.id || undefined
                    d.biz_supplie_apply_detail_id = d.biz_supplie_apply_detail_id
                    d.dic_supplies = { label: d.name || d.supplies.name, value: d.dic_supplies_id, jianpin: d.supplies && d.supplies.abbr }
                    d.spec = d.supplies.spec
                    d.category = d.supplies.category_model.name
                    return d
                })
                that.allData = r
                console.log(`loadData 加载的 that.allData`, that.allData)
                // resolve(r)
            })
        },
        SaveData(data, isscan) {
            let that = this
            let addData = _.filter(data, d => {
                return !(d.id && d.id != undefined)
            }).map(d => {
                return {
                    id: 0,
                    dic_supplies_id: (isscan && d.dic_supplies_id) || d.dic_supplies.value,
                    biz_supplie_apply_detail_id: d.biz_supplie_apply_detail_id,
                    apply_type: this.applytype,
                    use_quantity: (isscan && d.use_quantity) || 1, // 耗材登记，勾选新增默认为1
                    biz_surgery_info_id: this.surgeryId
                }
            })
            let updateData = _.filter(data, d => {
                return d.id && d.id != undefined
            }).map(d => {
                return {
                    id: d.id,
                    dic_supplies_id: d.dic_supplies.value,
                    biz_surgery_info_id: this.surgeryId,
                    biz_supplie_apply_detail_id: d.biz_supplie_apply_detail_id,
                    apply_type: this.applytype,
                    use_quantity: d.use_quantity
                }
            })
            console.log(`addData`, addData)
            console.log(`updateData`, updateData)
            let req = this.myaxios.post(`/api/Nursing/UseSupplies/PostMany`, addData)
            let req1 = this.myaxios.put(`/api/Nursing/UseSupplies/PutMany`, updateData)
            return new Promise((resolve, reject) => {
                this.myaxios
                    .all(req, req1)
                    .then(([data, data1]) => {
                        that.$message.success(`${isscan && `登记` || `保存`}成功！`)
                        that.loadData()
                        resolve()
                    })
                    .catch(e => reject(e))
            })
        },
        ExtraButtonClick(target) {
            if (this[target.emit]) {
                this[target.emit](target)
            } else {
                this.$emit(target.emit, target)
            }
        },
        selectionChange({ row }) {
            console.log(row)
            this.checkedRow = row
        },
        loadSupplyApplyView() {
            let that = this
            this.loadSupplyApply()
                .then(data => {
                    that.collectSupplyApply.dialogFormVisible = true
                    let info = data && data[0]
                    if (info) {
                        that.collectSupplyApply.selected_SupplyApply = info.id
                    }
                })
                .catch(e => {
                    console.log(e)
                })
        },
        loadSurgery() {
            let that = this
            if (!that.surgeryId) {
                that.inRoom = this.$moment()
                return
            }
            let req = that.myaxios.get(`/api/Preoperative/Apply/Get/${that.surgeryId}`)
            req.then(data => {
                if (data) {
                    that.inRoom = that.GetApplyDate(data.in_room)
                    that.roomid = data.dic_operating_room_id
                }
            }).catch(e => console.log(e))
        },
        GetApplyDate(roomtime) {
            let inRoomTime = (roomtime && this.$moment(roomtime)) || this.$moment()
            if (this.applytype == 1) {
                let startTime = inRoomTime.format(`YYYY/MM/DD HH:mm`)
                let sdate = inRoomTime.format(`YYYY/MM/DD ${this.supplyApplyScheduleTime}`)
                // 取申领时间为今天
                if (new Date(startTime) > new Date(sdate)) {
                    return inRoomTime.format(`YYYY/MM/DD`)
                } else {
                    return inRoomTime.add(`day`, -1).format(`YYYY/MM/DD`)
                }
            } else {
                return inRoomTime.format(`YYYY/MM/DD`)
            }
        },
        loadSupplyApply() {
            console.log(`inRoom`, this.inRoom)
            // 加载可选模板，弹出模板选择框
            this.collectSupplyApply.selected_SupplyApply = undefined
            this.collectSupplyApply.datalist = []
            this.collectSupplyApply.supplyApplyOption = []
            // 加载可用模板
            let that = this
            return new Promise((resolve, reject) => {
                let req = this.myaxios.get(`/api/AcisSystem/SupplieApply/GetApplyInfoBySurgeryId?from=${this.inRoom}&surgeryId=${that.surgeryId}&applytype=${that.applytype}`)
                req.then(data => {
                    if (data && data.length > 0) {
                        _.map(data, d => {
                            let r = {
                                label: d.title,
                                value: d.id,
                                code: this.$moment(d.apply_date).format(`YYYY/MM/DD`)
                            }
                            that.collectSupplyApply.supplyApplyOption.push(r)
                        })
                    }
                    that.supplyApplyOption = that.collectSupplyApply.supplyApplyOption
                    resolve(data)
                }).catch(e => reject(e))
            })
        },
        loadApplyDetail(applyid) {
            let that = this
            let req = that.myaxios.get(`/api/AcisSystem/SupplieApplyDetail/GetApplyDetail?applyId=${applyid}`)
            let req1 = that.myaxios.get(`/api/AcisSystem/Supplies/GetFixedSupplies?applytype=${this.applytype}`)
            this.myaxios
                .all(req, req1)
                .then(([detail, data1]) => {
                    that.supplyApplyDetailOption = []
                    console.log(data1)
                    let r = _.map(
                        _.filter(detail, d => {
                            return !d.suppliesInfo.is_deleted
                        }),
                        t => {
                            let idx = _.findIndex(data1, d => d.id == t.suppliesInfo.id)
                            if (idx > -1) {
                                data1.splice(idx, 1)
                            }
                            return {
                                biz_supplie_apply_detail_id: t.id,
                                dic_supplies: { label: t.suppliesInfo.name || t.suppliesInfo.name, value: t.suppliesInfo.id },
                                dic_supplies_id: t.suppliesInfo.id,
                                spec: t.suppliesInfo.spec,
                                category: t.suppliesInfo.category_model.name,
                                is_fixed: t.suppliesInfo.is_fixed,
                                quantity: (t.apply_count || 0) + (t.supplement_count || 0),
                                applyquantity: (t.add_quantity || 0) - (t.reduce_quantity || 0)
                            }
                        }
                    )

                    if (data1.length > 0) {
                        let fixes = _.map(data1,
                            t => {
                                return {
                                    biz_supplie_apply_detail_id: 0,
                                    dic_supplies: { label: t.name, value: t.id },
                                    dic_supplies_id: t.id,
                                    spec: t.spec,
                                    category: t.category_model.name,
                                    is_fixed: t.is_fixed,
                                    quantity: null,
                                    applyquantity: null
                                }
                            }
                        )
                        r = r.concat(fixes)
                    }
                    that.collectSupplyApply.datalist = r
                    _.map(r, d => {
                        that.supplyApplyDetailOption.push({ label: d.dic_supplies.label, value: d.biz_supplie_apply_detail_id })
                    })
                }).catch(e => console.log(e))
        },
        loadDamagedView() {
            this.supplyApplyDetailOption = []
            this.loadSupplyApply().then(d => {
                this.loadDamaged().then(data => {
                    this.damagedView.dialogFormVisible = true
                })
            })
        },
        loadDamaged() {
            return new Promise((resolve, reject) => {
                let req = this.myaxios.get(`/api/AcisSystem/DamagedSupplie/GetByBySurgeryId?surgeryId=${this.surgeryId}&applytype=${this.applytype}`)
                req.then(data => {
                    this.damagedView.damaged = data
                    resolve(data)
                }).catch(e => {
                    console.log(e)
                    resolve([])
                })
            })
        },
        deleteDamaged({ row, index }) {
            let that = this
            this.$confirm(`此操作将永久删除该记录, 是否继续?`, `提示`, {
                confirmButtonText: `确定`,
                cancelButtonText: `取消`,
                type: `warning`,
                closeOnClickModal: false
            }).then(() => {
                let req = this.myaxios.delete(`/api/AcisSystem/DamagedSupplie/Delete/${row.id}`)
                req.then(data => {
                    that.$message.success(`删除成功`)
                    this.loadDamaged()
                }).catch(e => {
                    console.log(e)
                })
            })
        },
        appendDamaged({ formdata }) {
            let that = this
            let item = _.find(that.supplyApplyDetailOption, { value: formdata.biz_supplie_apply_detail_id })
            console.log(item)
            let obj = {
                enum_stuff_destination: formdata.enum_stuff_destination,
                remark: formdata.remark,
                amount: formdata.amount,
                biz_surgery_info_id: that.surgeryId,
                apply_type: that.applytype,
                biz_supplie_apply_detail_id: formdata.biz_supplie_apply_detail_id
            }
            console.log(obj)
            if (obj.biz_supplie_apply_detail_id == undefined || obj.biz_supplie_apply_detail_id == null) {
                that.$message.error(`请选择耗材！`)
                return
            }

            let req = this.myaxios.post(`/api/AcisSystem/DamagedSupplie/Post`, obj)
            req.then(data => {
                this.loadDamaged()
            }).catch(e => {
                console.log(e)
            })
        },
        SaveUseSupplies() {
            console.log(`all`, this.allData)
            this.SaveData(this.allData)
        },
        addToList() {
            let diff = _.differenceBy(this.checkedRow, this.allData, item => {
                if (item.biz_supplie_apply_detail_id > 0) {
                    // 固定物资 不走 申请，每个biz_supplie_apply_detail_id 都=0,不能用来判断
                    return item.biz_supplie_apply_detail_id
                } else {
                    const relatedItem = this.allData.find(applydetail => applydetail.dic_supplies_id == item.dic_supplies.value)
                    return relatedItem ? relatedItem.dic_supplies_id : null
                }
            })
            console.log(`diff`, diff)
            if (this.checkedRow && this.checkedRow.length == 0) {
                this.$message.warning(`请至少勾选一条记录！`)
                return
            }
            this.SaveData(diff)
            this.collectSupplyApply.dialogFormVisible = false
        },
        removeItem({ row, index }) {
            let that = this
            if (row.id && row.id > 0) {
                this.$confirm(`此操作将永久删除该记录, 是否继续?`, `提示`, {
                    confirmButtonText: `确定`,
                    cancelButtonText: `取消`,
                    type: `warning`,
                    closeOnClickModal: false
                }).then(() => {
                    let req = that.myaxios.delete(`/api/Nursing/UseSupplies/Delete/${row.id}`)
                    req.then(data => {
                        that.$message.success(`删除成功！`)
                        that.loadData()
                    }).catch(e => {
                        that.$message.error(`删除失败`)
                    })
                })
            } else {
                that.allData.splice(index, 1)
            }
        },
        saveAsSuccess() {
            this.$message.success(`另存为模板成功`)
        },

        // 事件方法
        getReload() {
            this.reload() // 重置刷新
        },
        scanSupplies() {
            let that = this
            if (!this.scancode) {
                this.$message.warning(`请输入或扫码`)
                return
            }
            console.log(`inRoom`, this.inRoom)
            let req = this.myaxios.post(`/api/AcisSystem/SupplieApplyDetail/SupplieScan?barcode=${this.scancode}&from=${this.inRoom}&applytype=${that.applytype}&&roomid=${that.roomid}&&sApplyType=${that.sApplyType}`)
            req.then(data => {
                if (data && data.length > 0) {
                    var info = data[0]
                    let hadrow = _.find(that.allData, { dic_supplies_id: info.dic_supplies_id })
                    if (hadrow) {
                        that.allData = that.allData.map(d => {
                            if (d.dic_supplies_id == info.dic_supplies_id) {
                                d.use_quantity = 1 + parseInt(d.use_quantity || 0)
                            }
                            return d
                        })
                    } else {
                        that.allData.push({
                            id: 0,
                            dic_supplies_id: info.dic_supplies_id,
                            biz_supplie_apply_detail_id: info.id,
                            apply_type: that.applytype,
                            use_quantity: 1,
                            biz_surgery_info_id: that.surgeryId
                        })
                    }
                    that.SaveData(that.allData, true)
                    that.$refs[`scan-code`].scan_val = ``
                } else {
                    that.$message.warning(`暂无该耗材记录`)
                }
            }).catch(e => {
                console.log(e)
            })
        }
    },
    watch: {
        $route: function(newUrl, oldUrl) {
            this.getReload()
        },
        'collectSupplyApply.selected_SupplyApply': function(newval, oldval) {
            // 加载已选模板详情
            if (!newval) return
            let that = this
            that.loadApplyDetail(newval)
        }
    }
}
</script>
<style scoped lang="less">
.no-surgery {
    line-height: 600px;
    font-size: 24px;
    opacity: 0.5;
}
/deep/ .other {
    .use_quantity {
        color: red !important;
    }
}

/deep/ .otherqty {
    .back_quantity {
        color: red !important;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Surgery/Consumable/SupplyRegistration.vue